import type { ComposerPayloadContent } from './composerPayloadContent';
import type { ComposerPayloadMediaItem } from './composerPayloadMediaItem';
import type { ComposerPayloadPoll } from './composerPayloadPoll';
import type { ComposerPayloadTweetType } from './composerPayloadTweetType';

/**
 * JSON payload for tweet composer with media upload
 */
export interface ComposerPayload {
  content?: ComposerPayloadContent;
  media?: ComposerPayloadMediaItem[];
  poll?: ComposerPayloadPoll;
  /** @nullable */
  referencedTweetId?: string | null;
  /** @nullable */
  tweetType?: ComposerPayloadTweetType;
}
